export interface Product {
  id: string;
  name: string;
  application: "soil_drench" | "foliar";
  label_dose_text: string;
  pot_dose_text: string | null;
}

export async function fetchProducts(signal?: AbortSignal): Promise<Product[]> {
  const response = await fetch("/v1/products", { signal });
  if (!response.ok) throw new Error(`The API answered ${response.status}.`);
  const body: { products: Product[] } = await response.json();
  return body.products;
}
